import React, { createContext, useState } from "react";
import { Popup } from "./constants/constant";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  let screenName = "SplashScreen";
  let isLogedInState = false;
  const token = localStorage.getItem("JWTToken");
  if (token) {
    isLogedInState = true;
  } else if (localStorage.getItem("AppLanguage")) {
    localStorage.setItem("LoginScreen", "LoginPage");
    isLogedInState = false;
    localStorage.removeItem("updateMyProfile");
  } else {
    isLogedInState = false;
  }
  const [isLogedIn, setIsLogedIn] = useState(isLogedInState);
  const [screen, setScreen] = useState(screenName);
  const [lastScreen, setLastScreen] = useState("");
  const [errorPopup, setErrorPopup] = useState({
    show: "unset",
    type: Popup.APP_ERROR,
  });
  const [sourceContext, setSourceContext] = useState("");
  const [isAppInAppData, setIsAppInAppData] = useState("");
  console.log("CheckingSourceContext",sourceContext)

  return (
    <AppContext.Provider
      value={{
        lastScreen,
        setLastScreen,
        isLogedIn,
        setIsLogedIn,
        screen,
        setScreen,
        errorPopup,
        setErrorPopup,
        sourceContext,
        setSourceContext,
        isAppInAppData,
        setIsAppInAppData
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
